/**
 * EditarPartidaPresupuestoModal
 * Modal para editar una partida existente en un presupuesto
 */

import React, { useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import presupuestoHierarchyService from '../services/presupuestoHierarchyService';
import { toast } from 'react-toastify';
import './EditarRecursoPresupuestoModal.css';

const EditarPartidaPresupuestoModal = ({ partida, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    unidad: '',
    cantidad: ''
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (partida) {
      setFormData({
        nombre: partida.nombre || '',
        descripcion: partida.descripcion || '',
        unidad: partida.unidad || '',
        cantidad: partida.cantidad || ''
      });
    }
  }, [partida]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nombre.trim()) {
      toast.error('El nombre de la partida es requerido');
      return;
    }

    if (!formData.cantidad || parseFloat(formData.cantidad) <= 0) {
      toast.error('La cantidad debe ser mayor a 0');
      return;
    }

    setLoading(true);
    try {
      await presupuestoHierarchyService.updateVentaPartida(partida.id, {
        nombre: formData.nombre.trim(),
        descripcion: formData.descripcion.trim(),
        unidad: formData.unidad.trim(),
        cantidad: parseFloat(formData.cantidad)
      });

      toast.success('Partida actualizada exitosamente');
      onSuccess();
      onClose();
    } catch (error) {
      console.error('Error updating partida:', error);
      toast.error('Error al actualizar la partida');
    } finally {
      setLoading(false);
    }
  };

  if (!partida) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>Editar Partida</h2>
          <button
            className="close-btn"
            onClick={onClose}
            disabled={loading}
          >
            <FiX />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="nombre">Nombre de la Partida *</label>
            <input
              type="text"
              id="nombre"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              placeholder="Ej: Diseño"
              disabled={loading}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="descripcion">Descripción</label>
            <textarea
              id="descripcion"
              name="descripcion"
              value={formData.descripcion}
              onChange={handleChange}
              placeholder="Descripción detallada de la partida (opcional)"
              disabled={loading}
              rows="2"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="unidad">Unidad</label>
              <input
                type="text"
                id="unidad"
                name="unidad"
                value={formData.unidad}
                onChange={handleChange}
                placeholder="Ej: horas, días, unidad"
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="cantidad">Cantidad *</label>
              <input
                type="number"
                id="cantidad"
                name="cantidad"
                value={formData.cantidad}
                onChange={handleChange}
                placeholder="0.00"
                step="0.01"
                min="0"
                disabled={loading}
                required
              />
            </div>
          </div>

          <div className="modal-actions">
            <button
              type="button"
              className="btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={loading}
            >
              {loading ? 'Guardando...' : 'Guardar Cambios'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditarPartidaPresupuestoModal;
